<nz-table
	#overviewTable
	[nzData]="data.list"
	[nzPageIndex]="data.pagination.page"
	[nzPageSize]="data.pagination.pageSize"
	[nzTotal]="data.pagination.totalItems ?? 0"
	[nzLoading]="data.loading"
	[nzFrontPagination]="false"
	[nzShowPagination]="!draggingEnabled"
	(nzQueryParams)="queryParamsChange.emit($event)"
	nzTableLayout="fixed">
	<thead>
		<tr>
			<th
				nzColumnKey="sequenceNumber"
				nzAlign="center"
				nzWidth="40px"
				[nzShowSort]="false"
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.News,
						claimValues: [ClaimValues.Update]
					}
				]">
				<!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
				<label nz-checkbox [(ngModel)]="draggingEnabled" (ngModelChange)="draggingChanged()"></label>
			</th>
			<th
				nzWidth="110px"
				nzColumnKey="showOnline"
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.News,
						claimValues: [ClaimValues.Update]
					}
				]"
				[nzSortFn]="true"
				[nzSortOrder]="'descend'">
				{{ 'news.fields.show-online' | translate }}
			</th>
			<th nzColumnKey="title" [nzSortFn]="true" [nzShowSort]="!draggingEnabled">
				{{ 'news.fields.title' | translate }}
			</th>
			<th
				nzWidth="120px"
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.News,
						claimValues: [ClaimValues.Read, ClaimValues.Delete]
					}
				]"></th>
		</tr>
	</thead>
	<tbody cdkDropList (cdkDropListDropped)="drop($event)">
		<tr *ngFor="let row of overviewTable.data" cdkDrag [cdkDragData]="row" [cdkDragDisabled]="!draggingEnabled">
			<td
				nzAlign="center"
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.News,
						claimValues: [ClaimValues.Update]
					}
				]">
				<i class="fa-solid fa-grip-dots-vertical" cdkDragHandle></i>
			</td>
			<td
				nzAlign="center"
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.News,
						claimValues: [ClaimValues.Update]
					}
				]">
				<!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
				<label
					nz-checkbox
					[nzChecked]="row?.showOnline"
					(nzCheckedChange)="changeShowOnline(row.id, !row.showOnline)"></label>
			</td>
			<td>{{ row.title | truncateText }}</td>
			<td
				claimDirective
				[claims]="[
					{
						claimType: ClaimTypes.News,
						claimValues: [ClaimValues.Read, ClaimValues.Delete]
					}
				]">
				<div class="table-actions">
					<a
						claimDirective
						[claims]="[
							{
								claimType: ClaimTypes.News,
								claimValues: [ClaimValues.Read]
							}
						]"
						[routerLink]="['/nieuws/bewerken', row.id]"
						nz-button
						nzType="text"
						nzShape="circle">
						<i class="fa-regular fa-pen"></i>
					</a>
					<button
						claimDirective
						[claims]="[
							{
								claimType: ClaimTypes.News,
								claimValues: [ClaimValues.Delete]
							}
						]"
						nz-button
						nzDanger
						nzType="text"
						nzShape="circle"
						nz-popconfirm
						nzOkDanger
						[nzPopconfirmTitle]="'notification.delete' | translate"
						[nzOkText]="'common.delete' | translate"
						[nzCancelText]="'common.cancel' | translate"
						[nzIcon]="templateIconDelete"
						nzPopconfirmPlacement="left"
						(nzOnConfirm)="delete.emit(row.id)">
						<i class="fa-regular fa-trash-can"></i>
					</button>
				</div>
			</td>
		</tr>
	</tbody>
</nz-table>

<ng-template #templateIconDelete>
	<i nz-typography nzType="danger" class="fa-regular fa-trash-can"></i>
</ng-template>
